import * as React from 'react';
import { SnapcodeViewModel } from 'stageclip-common';

import { AppTextField } from '../../form/appTextField';
import { AppSelectField } from '../../form/appSelectField';
import { required, email, urlValidator, maxLength, integer } from '../../form/formValidations';

interface BaseParticipantFormFieldsProps {
  readonly?: boolean;
  isSurveyTurnedOn: boolean;
  isSnapchatTurnedOn: boolean;
  snapcodes: SnapcodeViewModel[];
}

const fullNameValidators = [required, maxLength(50)];
const subtitleValidators = [maxLength(90)];

export default class BaseParticipantFormFields extends React.Component<BaseParticipantFormFieldsProps> {
  snapcodes: Array<{ label: string; value: string }> = [];

  constructor(props: BaseParticipantFormFieldsProps) {
    super(props);

    const { snapcodes } = props;

    this.snapcodes = snapcodes.map(({ name, id }) => ({ label: name, value: id }));
  }

  public render() {
    const { readonly, isSurveyTurnedOn, isSnapchatTurnedOn } = this.props;
    const { snapcodes } = this;

    return (
      <>
        {/* <AppTextField readonly={readonly} name="fullName" label="Full Name" validate={fullNameValidators} /> */}
        <AppTextField readonly={readonly} name="firstName" label="First Name" validate={fullNameValidators} />
        <AppTextField readonly={readonly} name="lastName" label="Last Name" validate={fullNameValidators} />

        <AppTextField readonly={readonly} name="email" label="E-mail" validate={[email]} />
        <AppTextField readonly={readonly} name="subtitle" label="Subtitle" validate={subtitleValidators} />
        <AppTextField readonly={readonly} name="secondSubtitle" label="Second Subtitle" validate={subtitleValidators} />
        <AppTextField readonly={readonly} name="clientParticipantId" label="Client Participant Id" />
        <AppTextField
          readonly={readonly}
          name="marchingOrderParticipantId"
          label="Marching Order Participant Id"
          validate={integer}
        />
        {isSurveyTurnedOn && (
          <AppTextField name="surveyLink" label="Survey Individual Link" validate={[urlValidator]} />
        )}
        {isSnapchatTurnedOn && (
          <AppSelectField
            readonly={readonly}
            name="snapcodeId"
            label="Snapchat Barcode"
            options={snapcodes}
            disabled={!snapcodes.length}
          />
        )}
      </>
    );
  }
}
